import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import { PageCardType } from '@/types/card'
import { asPartnerLink } from '@/utils/helpers'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'

type Props = {
  bracket?: string
  budget?: string
  card: PageCardType
  tag?: string
}

const NavigationPanelTop = ({ bracket, budget, card, tag }: Props) => {
  const { dir } = useDirectories()
  const {
    background_chooser,
    cards,
    doctors_companion,
    is_partner,
    legal_commander,
    legal_companion,
    legal_partner,
    sanitized_wo,
    type,
  } = card
  const companionName = (sanitized_wo || '').split('-')[0]
  const isPartnerPair = is_partner && cards?.length === 2

  const buildLink = (base: string) =>
    `/${base}/${sanitized_wo}${bracket ? `/${bracket}` : ''}${tag ? `/${tag}` : ''}${budget ? `/${budget}` : ''}`

  return (
    <div className={styles.navButtons}>
      {legal_commander && (
        <LinkHelper href={buildLink('commanders')} primary={dir === 'commanders'} scroll={false}>
          As Commander
        </LinkHelper>
      )}
      {(legal_partner ||
        background_chooser ||
        doctors_companion ||
        type?.includes('Background') ||
        type?.includes('Time Lord Doctor')) && (
        <>
          {isPartnerPair ? (
            <>
              <LinkHelper ellipsis href={`/commanders/${cards[0].url}`} scroll={false}>
                {cards[0].name}
              </LinkHelper>
              {cards[1].legal_commander && (
                <LinkHelper ellipsis href={`/commanders/${cards[1].url}`} scroll={false}>
                  {cards[1].name}
                </LinkHelper>
              )}
            </>
          ) : (
            <LinkHelper href={asPartnerLink(card)} primary={['backgrounds', 'partners'].includes(dir)} scroll={false}>
              As Partner
            </LinkHelper>
          )}
        </>
      )}
      {legal_companion && (
        <LinkHelper
          disabled={['lutri', 'yorion'].includes(companionName)} // Lutri and Yorion are disabled (banned/impossible)
          href={`/tags/${companionName}-companion`}
          scroll={false}
        >
          As Companion
        </LinkHelper>
      )}
      {!isPartnerPair && (
        <LinkHelper href={`/cards/${sanitized_wo}`} primary={dir === 'cards'} scroll={false}>
          As Card
        </LinkHelper>
      )}
      {legal_commander && (
        <>
          <LinkHelper href={buildLink('average-decks')} primary={dir === 'average-decks'} scroll={false}>
            Average Deck
          </LinkHelper>
          <LinkHelper href={buildLink('decks')} primary={dir === 'decks'} scroll={false}>
            Decks
          </LinkHelper>
        </>
      )}
    </div>
  )
}

export default NavigationPanelTop
